import { Component } from '@angular/core';

@Component({
  selector: 'app-page-not-authorized',
  templateUrl: './page-not-authorized.component.html',
  styleUrl: './page-not-authorized.component.scss'
})
export class PageNotAuthorizedComponent {
	year = 2023
}
